module.exports = __webpack_public_path__ + "img/target-ratio-error.f927d563.png";